<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toasts, dismiss } = useToast()
</script>

<template>
  <div
    class="fixed bottom-4 right-4 z-[60] flex flex-col gap-2 w-[min(24rem,calc(100vw-2rem))]"
    aria-live="polite"
  >
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="flex items-start gap-2 rounded-md border px-4 py-3 shadow-md bg-white"
      :class="toast.tone === 'error' ? 'border-red-200' : 'border-green-200'"
      :role="toast.tone === 'error' ? 'alert' : 'status'"
    >
      <i
        :class="
          toast.tone === 'error' ? 'ti ti-alert-circle text-red-600' : 'ti ti-circle-check text-green-600'
        "
        class="text-lg"
        aria-hidden="true"
      ></i>
      <p class="flex-1 text-sm text-gray-800">{{ tr(toast.message) }}</p>
      <button
        type="button"
        class="text-default hover:text-gray-900"
        :aria-label="tr('Dismiss')"
        @click="dismiss(toast.id)"
      >
        <i class="ti ti-x" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>
